<form [formGroup]="formRegistroCliente">
    <mat-form-field>
      <mat-label>Código:</mat-label>
      <input
        matInput
        maxlength="30"
        placeholder="Insira o código"
        formControlName="codigoCliente">
    </mat-form-field>
    <mat-form-field [hidden]="usuario.perfilacessotipo==2">
      <mat-label>Cliente:</mat-label>
      <mat-select
      formControlName="cliente"
      disableOptionCentering="true"
      placeholder="Cliente">
                <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
        <mat-option selected value="">Selecione...</mat-option>
        <mat-option *ngFor="let c of clientesFiltrados | async"
        [value]="c.clienteid">{{c.nome}}</mat-option>
      </mat-select>
      <mat-hint class="w-100 text-right">Obrigatório</mat-hint>
    </mat-form-field>
    <button
     (click)="search()"
      mat-flat-button
      color="primary"
      class="mt-3"
      style="width: 100%"
      [disabled]="formRegistroCliente.invalid">
        Consultar <i class="fas fa-search"></i>
    </button>
  </form>
